import React from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import UserContext from '../common/UserContext';
import {Theme} from '@material-ui/core/styles';
import {ErrorMessage, Form, Formik} from 'formik';
import {FormDateRange} from '../../ext/lib/temporal';
import {makeStyles} from '@material-ui/core/styles';
import * as Yup from 'yup';

const useStyles = makeStyles((theme: Theme) => ({
  listItem: {
    padding: theme.spacing(1, 0)
  },
  title: {
    marginTop: theme.spacing(2)
  },
  formControl: {
    margin: theme.spacing(2)
  },
  group: {
    margin: theme.spacing(1, 0)
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1)
  }
}));

const ExportForm: React.FC = () => {
  const {apiToken} = React.useContext(UserContext);
  const classes = useStyles();

  return (
    <Formik
      initialValues={{
        firstDate: '',
        lastDate: ''
      }}
      validationSchema={
        Yup.object({
          firstDate: Yup.date().required('First date is required'),
          lastDate: Yup.date().required('Last date is required')
        })
      }
      validate={validateDateRange}
      onSubmit={handleSubmit}
    >{
      ({handleChange, handleBlur, values, errors, touched}) =>
        <Form>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="baseline"
          >
            <FormControl className={classes.formControl}>
              <TextField
                name="firstDate"
                value={values.firstDate}
                type="date"
                placeholder="YYYY-MM-DD"
                InputLabelProps={{shrink: true}}
                label="First date"
                variant="outlined"
                error={Boolean(errors.firstDate) && touched.firstDate}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <ErrorMessage name="firstDate">{makeFormErrorElement}</ErrorMessage>
            </FormControl>

            <FormControl className={classes.formControl}>
              <TextField
                name="lastDate"
                value={values.lastDate}
                type="date"
                placeholder="YYYY-MM-DD"
                InputLabelProps={{shrink: true}}
                label="Last date"
                variant="outlined"
                error={Boolean(errors.lastDate) && touched.lastDate}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <ErrorMessage name="lastDate">{makeFormErrorElement}</ErrorMessage>
            </FormControl>

            <Button
              variant="contained"
              color="primary"
              type="submit"
              size="large"
            >Get Billing Export</Button>
          </Grid>
        </Form>
    }</Formik>
  );

  async function handleSubmit({firstDate, lastDate}: FormDateRange): Promise<void> {
    const response = await fetch(`/api/v1/billing/${firstDate}/${lastDate}`, {
      method: 'GET',
      headers: {
        'Authorization': apiToken || 'unknown-token'
      }
    });
    
    if (response.status >= 500 && response.status < 600 ) {
      const errorData = await response.json();
      alert(errorData);
      return;
    }
    
    const csvUrl = (await response.json()).data;
    window.location.assign(csvUrl);
  }
};
export default ExportForm;

function makeFormErrorElement(msg: string): React.ReactElement {
  return <FormHelperText error>{msg}</FormHelperText>;
}

function validateDateRange({firstDate, lastDate}: {firstDate: string; lastDate: string}): Record<string, string> {
  return (lastDate < firstDate)
    ? {lastDate: 'Last day must not be sooner than First date'}
    : {};
}
